import React from "react";
import { Code2 } from "lucide-react";

interface VariableInserterProps {
  variables: string[];
  onInsert: (varName: string) => void;
  targetLabel?: string;
}

export const VariableInserter: React.FC<VariableInserterProps> = ({
  variables,
  onInsert,
  targetLabel,
}) => {
  if (!variables || variables.length === 0) {
    return (
      <p className="text-xs text-muted-foreground">
        Ten szablon nie ma dostępnych zmiennych.
      </p>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium text-foreground">
        <Code2 className="h-4 w-4 text-muted-foreground" />
        <span>Dostępne zmienne</span>
        {targetLabel && (
          <span className="text-xs font-normal text-muted-foreground">
            (wstaw do: {targetLabel})
          </span>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {variables.map((variable) => (
          <button
            key={variable}
            type="button"
            onClick={() => onInsert(variable)}
            className="inline-flex items-center rounded-md border border-border bg-muted/40 px-2 py-1 text-xs font-mono text-foreground transition-colors hover:bg-muted hover:border-primary/40"
            title={`Kliknij, aby wstawić {{${variable}}}`}
          >
            {`{{${variable}}}`}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        Kliknij na zmienną, aby wstawić ją w miejscu kursora.
      </p>
    </div>
  );
};
